/* eslint-disable import/prefer-default-export */
import { RECEIVE_OBJECT_VIEW, REQUEST_OBJECT_VIEW, OBJECT_VIEW_ERROR } from '../actions/activeObjectActions';
import { RECEIVE_PROCESS_VIEW } from '../actions/activeStateActions';

import { RECEIVE_LOGOUT_USER } from '../actions/activeUserActions';

const initialActiveObjectState = {
	isFetching: false,
	object: {
		iemClass: {
			attributes: [],
			guid: '',
			program: [],
			name: '',
		},
		states: [],
		parents: [],
		partstructureObjects: [],
		partstructureStates: [],
		partstructureReversed: [],
	},
	error: null,
};

export const activeObjectReducer = (state = initialActiveObjectState, action) => {
	switch (action.type) {
		case REQUEST_OBJECT_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_OBJECT_VIEW: {
			// sets new state and fetching ended
			const { iemClass, states, parents, partstructureObjects, partstructureStates, partstructureReversed } =
				action.payload;
			return {
				...state,
				object: { iemClass, states, parents, partstructureStates, partstructureObjects, partstructureReversed },
				isFetching: false,
			};
		}
		case OBJECT_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...initialActiveObjectState, isFetching: false };
		case RECEIVE_PROCESS_VIEW:
			// sets new state and fetching ended
			return { ...state, error: null };
		default:
			return state;
	}
};
